module.exports = __webpack_public_path__ + "img/classroom.61235254.png";